import CRMauth from "@/services/CRMinitAuth"

const endPoint = 'driving_schools'

const list = query => {
  return CRMauth.get(`${process.env.VUE_APP_CRM_API}${endPoint}/report/`, { params: query })
};

const post = data => {
  return CRMauth.post(`${process.env.VUE_APP_CRM_API}${endPoint}/`, data)
};

const put = (ID, data) => {
  return CRMauth.put(`${process.env.VUE_APP_CRM_API}${endPoint}/${ID}/`, data)
};

const remove = ID => {
  return CRMauth.delete(`${process.env.VUE_APP_CRM_API}${endPoint}/${ID}/`)
};


export default {
  list,
  post,
  put,
  remove
}